<template>
    <div class="row">
        <div
            v-if="loading"
            class="col-12 mt-5"
            v-loading="true"></div>
        <div v-else class="col-12">
            <card>
                <template slot="header">
                    <span v-if="$route.name === 'registration-type-groups-create'">Create new registration type group</span>
                    <span v-else>Edit Registration Type Group</span>
                </template>
                <el-form label-width="120px" :label-position="$store.state.props.isMobile ? 'top' : 'right'">
                    <el-form-item label="Name">
                        <el-input v-model="typeGroup.name"/>
                    </el-form-item>
                    <el-form-item label="Order">
                        <el-input v-model="typeGroup.order"/>
                    </el-form-item>
                    <el-form-item label="Registration Types">
                        <el-checkbox-group v-model="typeGroup.types">
                            <el-checkbox
                                v-for="type in $store.state.types"
                                :key="`registration-type-${type._id}`"
                                :label="type._id">
                                    {{ type.name }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-form>
                <template slot="footer">
                    <div class="d-flex justify-content-end">
                        <el-button
                            class="btn btn-primary"
                            @click="submit()"
                            :loading="saving">
                                Save
                        </el-button>
                    </div>
                </template>
            </card>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            typeGroup: {
                eventId: this.$route.params.eventId,
                name: '',
                order: 0,
                types: []
            },
            saving: false,
            loading: false
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        getData: async function () {
            this.loading = true
            try {
                await this.$store.dispatch('getAll', {
                    path: 'types',
                    params: {
                        filters: {
                            eventId: this.$route.params.eventId
                        }
                    }
                })

                if (this.$route.params.typeGroupId) {
                    const response = await this.$store.dispatch('get', { path: 'type-groups', key: 'typeGroup', id: this.$route.params.typeGroupId })
                    this.typeGroup = response.data.typeGroup
                }
            } catch (e) {
                console.log('error getting registration types')
            }
            this.loading = false
        },
        submit: async function () {
            try {
                this.saving = true
                if (this.$route.params.typeGroupId) {
                    await this.$store.dispatch('update', {
                        path: 'type-groups',
                        data: this.typeGroup,
                        id: this.$route.params.typeGroupId
                    })

                    this.$notify('Information successfully updated!')
                } else {
                    await this.$store.dispatch('create', {
                        path: 'type-groups',
                        data: this.typeGroup
                    })
                    this.$router.push({ name: 'registration-type-groups' })
                    this.$notify('Successfully created!')
                }
            } catch (e) {
                console.log('error saving new type group')
            }

            this.saving = false
        }
    }
}
</script>
